module.exports = __webpack_public_path__ + "img/error.215d6bd9.png";